import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NiceLayoutModule, NiceLoadingSpinnerModule } from "@recursyve/nice-ui-kit.v2";
import { PublicPageComponent } from "../../components/public-page/public-page.component";
import { PipesModule } from "../../pipes/pipes.module";
import { RegisterOwnerCodeFormModule } from "./components/register-owner-code-form/register-owner-code-form.module";
import { RegisterOwnerFormModule } from "./components/register-owner-form/register-owner-form.module";
import { RegisterComponent } from "./register.component";
import { RegisterQuery } from "./store/register.query";
import { RegisterService } from "./store/register.service";
import { RegisterStore } from "./store/register.store";

@NgModule({
    declarations: [RegisterComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        NiceLayoutModule,
        NiceLoadingSpinnerModule,
        PipesModule,
        RegisterOwnerCodeFormModule,
        RegisterOwnerFormModule,
        RouterModule,
        PublicPageComponent,
        TranslateModule
    ],
    providers: [RegisterQuery, RegisterService, RegisterStore],
    exports: [RegisterComponent]
})
export class RegisterModule {}
